import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_SUBCATEGORY, GET_SUBCATEGORY_BY_ID } from "../constants";
import { setGetCSVSubcategories, setGetSubcategories } from "../../reusableSlice";

export const getSubcategory = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/sub-categories", { params: data });
    const res = response?.data?.response || [];
    const key = data?.category_ids || "default"; // use appropriate key based on your data

    if (response?.data?.status) {
      dispatch({ type: GET_SUBCATEGORY, key, subcategorylist: res });
      dispatch(setGetSubcategories(res)); // optional if still needed
      return response;
    } else {
      dispatch({ type: GET_SUBCATEGORY, key, subcategorylist: [] });
    }
  } catch (err) {
    const key = data?.category_ids || "default";
    dispatch({ type: GET_SUBCATEGORY, key, subcategorylist: [] });
  }
};

export const addSubcategory =
  (data, setLoading, navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("admin/sub-categories", data);
      if (response?.data?.status) {
        navigate(-1);
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        return response;
      }

      swal({
        text: response?.data?.response?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };

export const updateSubcategory = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("admin/sub-categories", data);
    if (response?.data?.status) {
      console.log("iminside)", response);
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/subcategory")
      return response;
     
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const deleteSubcategory =
  (id, setLoading, params) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.delete(`admin/sub-categories/${id}`);
      if (response?.data?.status) {
       
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        dispatch(getSubcategory(params));
        return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };
export const getSubcategoryByID = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/sub-categories/${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_SUBCATEGORY_BY_ID,
        subcategorybyid: response.data.response,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
  }
};


export const getCSVSubcategory = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/sub-categories", { params: data });
    const res = response?.data?.response || [];
    if (response?.data?.status) {
      dispatch({ type: GET_SUBCATEGORY, subcategorylist: res });
        dispatch(setGetCSVSubcategories(response?.data?.response))
        return response
    } else {
      dispatch({ type: GET_SUBCATEGORY, subcategorylist: [] });
    }
  } catch (err) {
   // console.error(err);
    dispatch({ type: GET_SUBCATEGORY, subcategorylist: [] });
  }
};